import { LocalStorageService } from './LocalStorageService';
import { STORAGE_KEYS } from '../../constants/constants';
import { logger } from 'src/utils/logger';

/**
 * 用户选择管理服务
 * 负责管理用户选择的持久化和清理
 */
export class UserSelectionService {
  constructor(storageService = new LocalStorageService()) {
    this._storageService = storageService;
  }

  /**
   * 清除跨视图的用户选择
   * @param {string} newViewId - 新视图ID
   */
  clearCrossViewUserSelection(newViewId) {
    try {
      const lastSelectedUserStr = this._storageService.get(STORAGE_KEYS.LAST_SELECTED_USER);
      if (lastSelectedUserStr) {
        const lastSelectedUser =
          typeof lastSelectedUserStr === 'string'
            ? JSON.parse(lastSelectedUserStr)
            : lastSelectedUserStr;

        if (lastSelectedUser.viewId !== newViewId) {
          this._storageService.remove(STORAGE_KEYS.LAST_SELECTED_USER);
          logger.debug('[UserSelectionService] 切换视图，清除之前的用户选择');
        }
      }
    } catch (error) {
      logger.error('[UserSelectionService] 解析用户选择数据失败:', error);
      this._storageService.remove(STORAGE_KEYS.LAST_SELECTED_USER);
    }
  }
}
